import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { LoggerService } from '../logger-service/logger.service';
import { NotificationsService, Notification, NotificationType } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class ErrorNotificationService {

    constructor(
        private _logger: LoggerService,
        private _notification: NotificationsService,
        private _translate: TranslateService
    ) { }

    /**
     * Error handler that notifies user with a toast
     *
     * @param {error} http response error
     *
     * @memberOf ErrorNotificationService
     */
    public generateErrorNotification(error: any, operationType: string = '', path: string = '', isSaveall: boolean = false): void {
        let errorLabel = 'error';
        this._translate.get(errorLabel).subscribe((translated) => errorLabel = translated);
        let errorMsg = `${operationType} ${path}`;
        let errorHtml = (`${' '}${errorLabel}`).big().bold();

        try {
            if (error instanceof HttpErrorResponse && error.status === 0) {
                let errorConnectionLost = 'connection-error';
                this._translate.get(errorConnectionLost).subscribe((translated) => errorConnectionLost = translated);
                errorMsg = errorConnectionLost;
                errorHtml = errorConnectionLost.big().bold();

                let errorMessage = 'connection-lost';
                this._translate.get(errorMessage).subscribe((translated) => errorMessage = translated);
                errorMsg += `: ${errorMessage}`;
                errorHtml += `<br>${errorMessage}`;
            } else if (error instanceof HttpErrorResponse) {
                let body = error.error || '';
                if (body) {
                    const errorCode = body.code;
                    let message: string = body.message;
                    let errorCodeTranslated;
                    this._translate.get(errorCode).subscribe((translated) => errorCodeTranslated = translated);

                    if (errorCodeTranslated !== undefined && errorCodeTranslated !== errorCode) {
                        message = errorCodeTranslated;
                    }

                    if (message) {
                        errorMsg += ` : ${message}`;
                        errorHtml = message.big().bold();
                    } else {
                        errorMsg += errorLabel;
                        errorHtml = errorLabel.big().bold();
                    }

                    let bodyDetails = body.details;
                    if (bodyDetails && bodyDetails.length > 0) {
                        for (let details of bodyDetails) {
                            let detailTarget = details.target;
                            this._translate.get(detailTarget).subscribe((translated) => detailTarget = translated);

                            if (detailTarget) {
                                errorMsg += `detail: ${detailTarget}`;
                                errorHtml += `<br>${detailTarget.small().italics()}`;
                            }

                            const detailErrorCode = details.code;
                            let detailMessage: string = details.message;
                            this._translate.get(detailErrorCode).subscribe((translated) => detailMessage = translated);

                            if (detailMessage) {
                                errorMsg += `: ${detailMessage}`;
                                errorHtml += `<br>${detailMessage.small()}`;
                            }
                        }
                    } else {
                        let target = body.target;
                        this._translate.get(target).subscribe((translated) => target = translated);

                        if (target) {
                            errorHtml += `<br>${target.small().italics()}`;
                        }
                    }
                }
            } else if (error instanceof SyntaxError) {
                errorMsg = errorLabel;
                errorHtml = errorLabel.big().bold();
                let errorMessage = 'invalid-data';
                this._translate.get(errorMessage).subscribe((translated) => errorMessage = translated);
                errorMsg += `: ${errorMessage}`;
                errorHtml += `<br>${errorMessage}`;
            } else if (error instanceof RangeError) {
                let errorMessage = 'invalid-data';
                this._translate.get(errorMessage).subscribe((translated) => errorMessage = translated);
                errorMsg = errorMessage;
                errorHtml = errorMessage.big().bold();
                if (error.message) {
                    errorMsg += `: ${error.message}`;
                    errorHtml += `<br>${error.message.small()}`;
                }
            } else {
                if (error.message === 'End_of_Search') {
                    errorMsg = errorLabel;
                    errorHtml = errorLabel.big().bold();
                    let errorMessage = 'End of Search';
                    this._translate.get(errorMessage).subscribe((translated) => errorMessage = translated);
                    errorMsg += `: ${errorMessage}`;
                    errorHtml += `<br>${errorMessage}`;
                } else {
                    errorMsg = errorLabel;
                    errorHtml = errorLabel.big().bold();
                    let errorMessage = 'unexpected-error';
                    this._translate.get(errorMessage).subscribe((translated) => errorMessage = translated);
                    errorMsg += `: ${errorMessage}`;
                    errorHtml += `<br>${errorMessage}`;
                }
            }
        } catch (jsonError) {
            this._logger.error('Response Error', `Error can't be displayed: ${jsonError}`);
            errorMsg = errorLabel;
            errorHtml = errorLabel.big().bold();
            let errorMessage = 'internal-error';
            this._translate.get(errorMessage).subscribe((translated) => errorMessage = translated);
            errorMsg += `: ${errorMessage}`;
            errorHtml += `<br>${errorMessage}`;
        }

        this._logger.error('Error', `Message: ${errorMsg}`);
        this._logger.storeLogArray('Error', `${errorLabel} : ${errorMsg}`);

        if (!isSaveall) {
            this._notification.html(
                `<aside class="flex-container nowrap flex-align-center notification notification--error icon__svg">
                    <span class="flex-item-fluid pas">${errorHtml}</span>
                </aside>`,
                NotificationType.Bare,
                { timeOut: 0 }
            );
        }
    }
}
